import { Row, Select, FormInstance } from "antd";
import type { NamePath } from "antd/es/form/interface";
import { CloseOutlined } from "@ant-design/icons";
import { CriteriaOption } from "../../../../types/bulkEmails/CriteriaOption";
import { CriteriaRowModel } from "../../../../types/bulkEmails/CriteriaRowModel";
import { useCallback } from "react";

export const CriteriaRow = ({
  form,
  row,
  options,
  usedOptions,
  formKey,
  onChange,
  onRemove
}: {
  form: FormInstance;
  row: CriteriaRowModel;
  options: CriteriaOption[];
  usedOptions: string[];
  formKey: NamePath;
  onChange: (row: CriteriaRowModel) => void;
  onRemove: (rowId: string) => void;
}) => {
  const selectedOption = options.find((option) => option.key === row.optionKey);

  const handleOptionChange = useCallback(
    (optionKey: string) => {
      onChange({ ...row, optionKey, value: undefined });
    },
    [onChange, row]
  );

  const handleOnRemove = useCallback(() => {
    onRemove(row.id);
  }, [row, onRemove]);

  const handleValueChange = useCallback(
    (value: unknown) => {
      onChange({ ...row, value });
    },
    [onChange, row]
  );

  return (
    <Row className="mx-2 mb-2 align-start">
      <Row className="criteria-option">
        <Select
          disabled={!row.removable}
          value={row.optionKey}
          className="w-100"
          options={options.map((option) => ({
            label: option.title,
            value: option.key,
            disabled: option.key !== row.optionKey && usedOptions.includes(option.key)
          }))}
          onChange={handleOptionChange}
        />
      </Row>
      <Row className="justify-center equality-sign">
        <span className="text">&nbsp;=&nbsp;</span>
      </Row>
      <Row className="criteria-value">
        {selectedOption?.render?.({
          value: row.value,
          form: form,
          formKey: formKey,
          onChange: handleValueChange
        })}
      </Row>
      {row.removable && (
        <Row className="justify-center remove-criteria">
          <CloseOutlined className="ml-2 text-md title logo-cursor" onClick={handleOnRemove} />
        </Row>
      )}
    </Row>
  );
};
